/* eslint-disable @repo/internal/react/require-jsdoc */

import React, { type ReactNode } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const styles = xcss({
	width: '100%',
	maxWidth: '1028px',
	paddingInline: 'space.150',
	'@media (min-width: 48rem)': {
		paddingInline: 'space.300',
	},
});

export const PageContentContainer = ({ children }: { children: ReactNode }) => {
	return <Box xcss={styles}>{children}</Box>;
};
